<template>
  <div class="page trips-confirm">
    <h1>Bevestig ritten</h1>
  </div>
</template>

<script>
export default {
  name: "TripsConfirm"
}
</script>
